import React, { Component } from 'react';
import _ from "lodash";
import moment from "moment";
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import TextAutocompleteInput from "./TextAutocompleteInput";
import Header from "./Header";



class SalesDashboard extends Component {

  state={
  };

  static getDerivedStateFromProps(props,state) {
    return {};
  }

  componentDidMount() {
    this.props.getGruviItems();
  }


  render() {
    console.log(this.props.movies)
    if(Object.keys(this.props.movies).length === 0 ){
      return ( 
        <div className="sales-dashboard">
          <Header authed={this.props.authed}  homepageShowAllToggle={this.props.homepageShowAllToggle} homepageShowAll={this.props.homepageShowAll} logout={this.props.logout}/>
          <div className="page__content">
            <Link className="header__back" to="/">Back</Link>
            <p>loading</p>
          </div>
        </div>
      );
    }

    return (
      <div className="sales-dashboard">
        <Header authed={this.props.authed}  homepageShowAllToggle={this.props.homepageShowAllToggle} homepageShowAll={this.props.homepageShowAll} logout={this.props.logout} setRedirect={this.props.setRedirect}/>
        <div className="page__content">
          <Link className="header__back" to="/">Back</Link>
        </div>
      </div>
    );
  }
}

export default SalesDashboard;



// WEBPACK FOOTER //
// ./src/components/SalesDashboard.js